// @ts-nocheck
import React, { useState, useEffect } from "react";
import { ConfigProvider } from "antd";
import Loadable from "react-loadable";
import intl from "react-intl-universal";
import { appLocales, antdLocales } from "@/config/locales";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

const langObj = {
  "zh-CN": "zh-CN",
  "en-US": "en-US",
};

const loadableProps = {
  timeout: 60 * 1000,
};
const Loading = () => null;

const Index = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Index" */ "@/pages/Index/Index"),
  loading: Loading,
});

const Price = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Price" */ "@/pages/Price/Price"),
  loading: Loading,
});

const About = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "About" */ "@/pages/About/About"),
  loading: Loading,
});

const NotFound = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "NotFound" */ "@/pages/NotFound/NotFound"),
  loading: Loading,
});

const Bp = () => (
  <iframe
    src="/bp.html"
    style={{ width: "100%", height: "100vh", border: "none", display: "block" }}
    title="bp"
  />
);

const BpEn = () => (
  <iframe
    src="/bp_en.html"
    style={{ width: "100%", height: "100vh", border: "none", display: "block" }}
    title="bp_en"
  />
);

function App() {
  const [antdLang, setAntdLang] = useState<any>(antdLocales["zh-CN"]);
  const [initLocaleDone, setInitLocaleDone] = useState<boolean>(false);

  const loadLocales = () => {
    const navigatorLanguage = navigator.language || "zh-CN";
    const lang = langObj[navigatorLanguage] || "zh-CN";
    intl
      .init({
        currentLocale: lang,
        locales: appLocales,
      })
      .then(() => {
        setAntdLang(antdLocales[lang]);
        setInitLocaleDone(true);
      });
  };

  useEffect(() => {
    loadLocales();
  }, []);

  return (
    initLocaleDone && (
      <ConfigProvider locale={antdLang}>
        <Router>
          <Switch>
            <Route exact path="/" render={() => <Index />} />
            <Route exact path="/price" render={() => <Price />} />
            <Route exact path="/about" render={() => <About />} />
            <Route exact path="/bp" render={() => <Bp />} />
            <Route exact path="/bp_en" render={() => <BpEn />} />
            <Route component={NotFound} />
          </Switch>
        </Router>
      </ConfigProvider>
    )
  );
}

export default App;
